<template>
  <div class="dbc-gl-page">
    <TheHeader
      v-if="hasHeaderAndFooter() && !isWebview()"
      class="print:hidden"
      :page="page"
      :logo="config?.logo"
    />
    <main class="dbc-gl-content">
      <slot />
    </main>
    <TheFooter
      v-if="hasHeaderAndFooter() && !isWebview()"
      class="print:hidden"
    />
    <DbcCopyright
      v-if="copyrights && copyrights.length > 0 && !isWebview()"
      :copyrights="copyrights"
    />
  </div>
</template>

<script setup lang="ts">
const page = useAttrs().page as Page
const copyrights = useAttrs().copyrights as string[]
const config = inject('configuration') as Ref<Config>
</script>
